module.exports = __webpack_public_path__ + "img/identity.394e9823.png";